export function firebaseSuccessAction(type) {
  return result => ({
    type: type,
    payload: result,
  })
}

export function firebaseErrorAction(error, type) {
  return {
    type: type,
    payload: error,
  }
}



// WEBPACK FOOTER //
// ./src/modules/firebase/actions.js